import { useContext } from "react";
import StateContext from "../context/StateContext";
import { mergeObjects, prepWithExtras } from "../services/dataService";
import { getSegmentsByMail } from "../services/globalService";
/**
 * @returns {function} getSegmentHits(segments, time_frame)
 */
const useSegments = () => {
	const { customer, segments, hitsMap } = useContext(StateContext);

	/**
	 *
	 * @param {string} time_frame
	 * @returns {object} {newHitsMap}
	 */
	const getSegmentHits = async (time_frame) => {
		if (!(segments && segments.length)) return {};
		let newHitsMap = {};
		// if no fixel data - prep segments list and continue
		if (hitsMap) newHitsMap = { ...hitsMap };
		// check if all segments have hits for given time_frame
		const timeFrameMissing = !hitsMap || segments.some(({ code }) => !hitsMap[code] || !hitsMap[code].hasOwnProperty(time_frame));
		if (timeFrameMissing) {
			const resWithExtras = await getSegmentsByMail({ mail: customer?.mail, time_frame, extras: ["hits", "prevHits"] });
			const { hitsMap: _hitsMap } = prepWithExtras({ segments: resWithExtras.data, time_frame: time_frame });
			newHitsMap = mergeObjects(hitsMap, _hitsMap);
		}

		return { newHitsMap };
	};
	return { getSegmentHits };
};

export default useSegments;
